import React, { useEffect, useState } from 'react';
import customEventBus from '@common/scripts/libs/eventBus';
import analytics from '@common/utils/analytics';
import { useTranslation } from 'react-i18next';
const WishlistButton = (props) => {
    const { t } = useTranslation();
    const [wishlistCount, setWishlistCount] = useState(window.wishlistIds.length);
    useEffect(() => {
        customEventBus.on('account:update', (data) => {
            let adding = false;
            if (data === null || data === void 0 ? void 0 : data.wishlistIds) {
                if (data.wishlistIds.length > window.wishlistIds.length) {
                    // adding to wishlist
                    adding = true;
                }
                window.wishlistIds = data.wishlistIds;
                setWishlistCount(data.wishlistIds.length);
            }
        });
    }, []);
    return (React.createElement("a", { className: 'icon--heart-' + (wishlistCount > 0 ? 'filled' : 'empty') + '-black account-wrapper', "data-analytics": '{"event": "menu", "eventCategory": "account menu", "eventAction": "my moncler", "eventLabel": "wishlist"}', href: props.wishlistLink, onClick: () => analytics.header('wishlist', true), "aria-label": t('button.viewyourwishlist') }));
};
export default WishlistButton;
